<template>
    <el-card shadow="hover" class="site-card" @click="handleSiteCard" v-if="device !== 'mobile'">
      <div class="line">
        <el-aside class="site-card-aside"  v-if="device !== 'mobile'">
          <el-image
            loading="lazy"
            class="site-card-logo"
            fit="contain"
            :src="getPictureShowUrl(site.sitePath)"
          >
            <template #error>
              <el-image
                loading="lazy"
                class="site-card-logo"
                fit="contain"
                :src="getPictureShowUrl(defaultSiteImage)"
              />
            </template>
          </el-image>
        </el-aside>
         <el-main class="site-card-main">
            <a
              class="content"
              ><svg-icon icon-name="star" class="little" /><strong>{{ site.siteName }}</strong></a
            ><br/>
             <a
              class="content"
              ><svg-icon icon-name="click" class="little" /> {{ site.clickCount }} </a
            ><br/>
           <a
              class="content"
              ><svg-icon icon-name="component" class="little" /> {{ site.categoryName }} </a
            ><br/>

             <el-button type="primary" class="playnow"  >PLAY NOW!</el-button>
         </el-main>
      </div>
    </el-card>
    <el-card shadow="hover" class="site-card-mobile" @click="handleSiteCard" v-if="device === 'mobile'">
      <div class="line">
         <el-aside class="site-card-aside-mobile"  v-if="device === 'mobile'">
                  <el-image
                    loading="lazy"
                    class="site-card-logo-mobile"
                    fit="contain"
                    :src="getPictureShowUrl(site.sitePath)"
                  >
                    <template #error>
                      <el-image
                        loading="lazy"
                        class="site-card-logo-mobile"
                        :src="getPictureShowUrl(defaultSiteImage)"
                      />
                    </template>
                  </el-image>
         </el-aside>
         <el-main class="site-card-main">
                           <a
                            class="content"
                            ><svg-icon icon-name="click" class="little" /> {{ site.clickCount }} </a
                          ><br/>
                         <a
                            class="content"
                            ><svg-icon icon-name="component" class="little" /> {{ site.categoryName }} </a
                          ><br/>
               <el-button type="primary" class="playnow"  >PLAY NOW!</el-button>
         </el-main>
      </div>
      <div
          class="title"
          ><svg-icon icon-name="star" class="little" /><strong>{{ site.siteName }}</strong> </div
        >
    </el-card>
</template>
<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { openSite } from '@/utils/geshanzsq'
const device = computed(() => store.getters['app/device'])
const props = defineProps({
  // 网站信息
  site: {
    type: Object
  },
  // 改变标题颜色
  changeTitleColor: {
    type: Boolean,
    default: true
  },
  // 是否打开网站
  openSite: {
    type: Boolean,
    default: true
  },
  // 是否开启描述提示
  disabledTip: {
    type: Boolean,
    default: true
  }
})

const store = useStore()

// 默认图片
const defaultSiteImage = ref('/profile/site/system/logo.jpg')

/**
 * 网站卡片点击事件
 */
function handleSiteCard() {
  if (!props.openSite) {
    return
  }
  openSite('/detail/get/' + props.site.id)
}
</script>
<style lang="scss" scoped>
.site-card {
background-color: transparent;
  cursor: pointer;
  border: none;
   width: 290px;
   Height:140px;
   margin-bottom:10px;
  .description{
         margin-bottom: 10px;
         margin-left: 10px;
         font-size: 12px;
         overflow: ellipsis;
         color:grey;
  }
  .line{
      .site-card-aside {
        background-color: transparent;
        width: 160px;
        Height:160px;
        padding: 0px;
        margin: 0px;
        text-align: center;
          .site-card-logo {
            border-radius: 15%;
            width: 140px;
            height: 140px;
            justify-content: center;
          }
      }
  .site-card-main {
        padding-left: 0px;
        margin-left: 0px;
        width: 180px;
       .little{
            width: 1em;
             height: 1em;
        }
        .site-title {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          font-size: 10px;
          text-align: center;
          color: #fff;
        }
   }
   display: flex;
   padding-top: 0px;
   margin-top: 0px;
   align-items: center;
     .content{
     padding-top: 0px;
      font-size: 14px;
        overflow: hidden;
     }
   }
     .playnow{
     margin-top: 5px;
     margin-left: 0px;
      width: 100px;
      Height:30px;
      font-size: 9px;
         align-items: center;
         justify-content: center;
         border-radius: 10rem;
         background: linear-gradient(141deg, #ff0000 20%, #ffa500 80%);
     }
}
.site-card-mobile {
   cursor: pointer;
   border: none;
   width: 170px;
   Height:105px;
   padding: 0px;
   margin-bottom:10px;
   background-color: transparent;
    .description{
              padding-bottom: 10px;
               margin-left: 5px;
               font-size: 12px;
               overflow: ellipsis;
                color:grey;
              }
    .title{
             margin-bottom: 10px;
             margin-left: 0px;
             font-size: 12px;
             overflow: ellipsis;
              .little{
                                   width: 1em;
                                    height: 1em;
                               }
      }
     .line{
   .site-card-aside-mobile {
      background-color: transparent;
      width: 85px;
      Height:90px;
      padding: 0px;
      margin: 0px;
      .site-card-logo-mobile {
        border-radius: 15%;
        padding: 0px;
        margin:0px;
        display:flow;
        width: 85px;
        height: 85px;
      }
    }
     .site-card-main {
          padding: 0px;
          margin: 0px;
          align-items: center;
          justify-content: center;
           width: 85px;
          .site-title {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            font-size: 9px;
            text-align: center;
            color: #000;
          }
           .little{
                      width: 1em;
                       height: 1em;
                  }
          }
             display: flex;
             padding-top: 0px;
             margin-top: 0px;
             align-items: center;
               .content{
               padding-top: 0px;
               padding-left: 5px;
                font-size: 12px;
                overflow: hidden;
               }
             }
           .playnow{
                 margin-top: 5px;
                 margin-left: 0px;
                 width: 85px;
                 Height:25px;
                 font-size: 9px;
                 align-items: center;
                 justify-content: center;
                 border-radius: 10rem;
                 background: linear-gradient(141deg, #ff0000 20%, #ffa500 80%);
               }
     }

</style>
